import React from "react";
import "style/SliderBoxItems.scss";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import SvgSliderArrowRight from "assets/SvgSliderArrowRight.svg";
import SvgSliderArrowLeft from "assets/SvgSliderArrowLeft.svg";

function SampleNextArrowImg(props: any) {
  const { className, style, onClick } = props;
  return (
    <>
      <div
        className={className + " slider-box-items-arrow-next"}
        style={{
          ...style,
          display: "block",
          right: "20px",
        }}
        onClick={onClick}
      >
        <img
          src={SvgSliderArrowRight}
          className="svg-slider-arrow-right"
          alt={"SliderNext"}
        />
      </div>
    </>
  );
}
function SamplePrevArrowImg(props: any) {
  const { className, style, onClick } = props;
  return (
    <>
      <div
        className={className}
        style={{
          ...style,
          display: "block",
          left: "15px",
          zIndex: "1",
        }}
        onClick={onClick}
      >
        <img
          src={SvgSliderArrowLeft}
          className="svg-slider-arrow-left"
          alt={"SliderPrev"}
        />
      </div>
    </>
  );
}

interface Props {
  id?: number;
  image?: string;
  name?: string;
  title?: string;
  text?: string;
}

interface State {
  active: boolean;
}

class SliderBoxItems extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      active: false,
    };
  }

  render() {
    const path = this.props.name;
    const img = require(`assets/image/${path}.webp`);
    const classNameImgFirst =
      "img-" + this.props.name?.toLowerCase() + " slider-image";
    const classnameImageText = () => {
      const id = this.props.id;
      if (id) {
        if (id % 2 === 0) return "image-text-left";
        else return "image-text-right";
      }
    };
    const classNameImageText = classnameImageText();

    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <SampleNextArrowImg />,
      prevArrow: <SamplePrevArrowImg />,
      appendDots: (dots: any) => (
        <div>
          <ul> {dots} </ul>
        </div>
      ),
    };

    return (
      <div
        className="slider-main"
        style={{
          paddingBottom: "20px",
        }}
      >
        <Slider {...settings}>
          <div className="slider-box-image-main">
            <img src={img} alt="img" className={classNameImgFirst} />
            <div className={classNameImageText}>
              <h2>{this.props.title}</h2>
              <p>{this.props.text}</p>
            </div>
          </div>

          <div style={{ display: "inline-block" }}>
            <img src={img} alt="img" className={classNameImgFirst} />
          </div>

          <div style={{ display: "inline-block" }}>
            <img src={img} alt="img" className={classNameImgFirst} />
          </div>
        </Slider>
      </div>
    );
  }
}

export default SliderBoxItems;
